import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { motion, useScroll, AnimatePresence } from "framer-motion";
import Preloader from "@/components/Preloader";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Playground from "@/components/Playground";
import WhyUs from "@/components/WhyUs";
import Environment from "@/components/Environment";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import SoundToggle from "@/components/SoundToggle";
import { LanguageProvider } from "@/lib/i18n";

export default function Home() {
  const [loading, setLoading] = useState(true);
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
    <div className="bg-[#050505] text-neutral-100 min-h-screen" data-testid="home-page">
      <div className="noise-overlay" aria-hidden="true" />
      <AnimatePresence>
        {loading && <Preloader onComplete={() => setLoading(false)} />}
      </AnimatePresence>
      <CustomCursor />
      <motion.div
        className="fixed top-0 left-0 right-0 h-[2px] bg-[#FF5A00] z-[120] origin-left"
        style={{ scaleX: scrollYProgress }}
        data-testid="scroll-progress"
      />
      <Navbar />
      <main>
        <Hero active={!loading} />
        <Marquee />
        <Services />
        <Playground />
        <WhyUs />
        <Environment />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
      <SoundToggle />
      <Toaster position="bottom-center" theme="dark" />
    </div>
    </LanguageProvider>
  );
}
